import React from 'react'

import Translator from 'bazinga-translator'
import Button from 'components/Btn'
import { GameWithUserInformation } from 'containers/GamesBlock/types'
import { useUser } from 'containers/MainLayout/selectors'

import useGameDialog from '../MobileDialog/hooks/useGameDialog'

interface Props {
  game: GameWithUserInformation
}

export function PlayForFunButton({ game }: Props) {
  const { isPlayForFunPermitted } = useUser()
  const { close } = useGameDialog()
  const { forFunPlayUrl } = game

  if (!isPlayForFunPermitted) {
    return null
  }

  return (
    <Button
      sm
      link
      onClick={() => close()}
      href={forFunPlayUrl}
    >
      {Translator.trans('play_for_fun', {}, 'games')}
    </Button>
  )
}
